import { render } from "./FileDetailView.vue?vue&type=template&id=527997c4&scoped=true"
import script from "./FileDetailView.vue?vue&type=script&lang=js"
export * from "./FileDetailView.vue?vue&type=script&lang=js"

import "./FileDetailView.vue?vue&type=style&index=0&id=527997c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-527997c4"]])

export default __exports__